module.exports = __webpack_public_path__ + "static/media/close_white_icon.0e4021b0.svg";